"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

require("./Style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AboutUs = function AboutUs(props) {
  return _react2.default.createElement(
    "section",
    {
      id: "aboutUs",
      className: [!props.template ? "temp-1" : "temp-" + props.template, !props.theme ? "light" : props.theme].join(" ")
    },
    props.description ? _react2.default.createElement(
      _react2.default.Fragment,
      null,
      _react2.default.createElement(
        "div",
        { className: "aboutContent" },
        _react2.default.createElement(
          "h2",
          null,
          _react2.default.createElement(
            "span",
            null,
            props.title
          )
        ),
        props.description ? _react2.default.createElement(
          "p",
          null,
          props.description
        ) : "Please add some description"
      ),
      _react2.default.createElement("div", {
        className: "aboutImg",
        style: {
          backgroundImage: props.image && props.image !== undefined ? "url('" + props.image + "')" : "none"
        }
      })
    ) : _react2.default.createElement(
      "div",
      { className: "modNoData" },
      "No description received"
    )
  );
};

exports.default = AboutUs;